import React, {RefObject, useEffect, useRef, useState} from 'react';
import {AnimatePresence, motion} from 'framer-motion';

import { Language } from  '@/interfaces/languages';



const LanguageSettingsTable = ({language, settingsSelection, setSettingsSelection}:{language?:Language, settingsSelection?: number, setSettingsSelection:(number: number) => void}) => {
   
    const [showWarning, setShowWarning] = useState<boolean>(false)

    const radio1 = useRef<HTMLInputElement>(null);
    const radio2 = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (radio1.current && settingsSelection === 1){
            radio1.current.checked = true;
            setShowWarning(true)
        }

        else if (radio2.current && settingsSelection === 0){
            radio2.current.checked = true
            setShowWarning(false)
        }
    }, [settingsSelection])


    function outerClick(ref:React.RefObject<HTMLInputElement>) {

        if (ref.current){
            ref.current.checked = true;

            setSettingsSelection(parseInt(ref.current.value))
        }
    }

    const name = language ? language.name : '';
    
    return (
        <>
            <label onClick={() => outerClick(radio2 as RefObject<HTMLInputElement>)}>
                <div>
                    Make {name} available and allow Editors to manually select {name} when creating new or editing existing content.
                </div>
                <div>
                    <input type="radio" name="selection" value="0" ref={radio2} />
                </div>
            </label>

            <label onClick={() => outerClick(radio1 as RefObject<HTMLInputElement>)}>
                <div>
                    Make {name} available for all content and automatically have {name} selected when creating new or editing existing untranslated content.
                </div>
                <div>
                    <input type="radio" name="selection" value="1" ref={radio1} />
                </div>  
            </label>


            <AnimatePresence>
                {showWarning && (
                    <motion.div
                        className='warning'
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        Content items that have translations saved will ignore automatic default settings
                    </motion.div>
                )}
            </AnimatePresence>

        </>
    );
};

export default LanguageSettingsTable;